import { useEffect, useState } from "react";

/**
 * The step a scene is at: it moves to the next one after the duration of the current one, round and round, only while
 * `active`. Without movement the scene stays at its last step, the one that tells the end of the story.
 */
export function useSceneTimeline(durations: readonly number[], active: boolean, still: boolean): number {
  const [step, setStep] = useState(0);
  useEffect(() => {
    if (!active || still) return;
    let current = 0;
    let timer: ReturnType<typeof setTimeout>;
    const next = () => {
      timer = setTimeout(() => {
        current = (current + 1) % durations.length;
        setStep(current);
        next();
      }, durations[current]);
    };
    next();
    return () => {
      clearTimeout(timer);
      setStep(0);
    };
  }, [durations, active, still]);
  return still ? durations.length - 1 : step;
}
